import { jsx as _jsx } from "react/jsx-runtime";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as authSelectors from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.selectors";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasSsoSession, setReturnUrlAfterLogin, } from "../../scenes/Auth/Auth.utils";
export var PrivateRoute = function () {
    var hasAccessToken = useSelector(authSelectors.hasAccessToken);
    var location = useLocation();
    var user = authHooks.useSelf().user;
    var _a = user || {}, unverifiedEmail = _a.unverifiedEmail, email = _a.email, unverifiedPhone = _a.unverifiedPhone, unverifiedPhoneIsVerifiable = _a.unverifiedPhoneIsVerifiable;
    if (unverifiedPhone && unverifiedPhoneIsVerifiable) {
        return _jsx(Navigate, { to: { pathname: "/auth/verify/phone" } });
    }
    if (unverifiedEmail) {
        return _jsx(Navigate, { to: { pathname: "/auth/verify/email" } });
    }
    if (!hasAccessToken) {
        // Sign in and come back here, rather than landing on the dashboard. A link
        // in a mail points at one screen, and being dropped on the overview after
        // signing in means finding that screen again by hand. Every sign-in route
        // reads this back through useNavigateAfterSuccess.
        setReturnUrlAfterLogin("".concat(location.pathname).concat(location.search));
        // An SSO session refreshes in the background like any other, so this only happens once
        // the refresh is refused (the user was suspended) or the session was signed out.
        // /auth/signin is the one page that cannot let them back in — their office's
        // enforceSsoOnly setting makes the API refuse email and phone sign-in — so they go back
        // to the page that can, with the address they typed still filled in. The return url is
        // set either way, so both routes land them back where they were.
        return (_jsx(Navigate, { to: { pathname: hasSsoSession() ? "/auth/sso" : "/auth/signin" } }));
    }
    if (!unverifiedEmail && !email) {
        return _jsx(Navigate, { to: { pathname: "/auth/edit-email" } });
    }
    return _jsx(Outlet, {});
};
